import { AfterContentInit, Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { createForm, FormType, subformComponentProviders } from 'ngx-sub-form';
import { InputNumber } from 'primeng/inputnumber';

export interface UomQuantityInput {
  control: number;
}
@Component({
  selector: 'app-uom-input',
  template: `
    <form [formGroup]="form.formGroup">
      <label>
        {{ label }}
      </label>
      <app-validated-number-input
        [id]="control"
        [control]="inputControl()"
        [value]="inputControl().value"
        [validation]="{ min: min, max: max }"
        [unit]="unitLabel"
        [title]="title || label"
      ></app-validated-number-input>
    </form>
  `,
  providers: subformComponentProviders(UomQuantityInputComponent),
  standalone: false
})
export class UomQuantityInputComponent implements OnInit, OnChanges, AfterContentInit {
  public inputControl(): UntypedFormControl {
    return this.form.formGroup.controls.control as UntypedFormControl;
  }

  @Input()
  public label: string;

  @Input()
  public unitLabel: string;

  @Input()
  public min?: number;

  @Input()
  public max?: number;

  @Input()
  public title?: string;

  @Input()
  public default?: number;

  @Input()
  public inputDisabled?: boolean;

  @Input()
  public control: string;

  @Input()
  public validators: any[];

  @ViewChild('pnInput')
  public pnInput: ElementRef;

  public form = createForm<UomQuantityInput, any>(this, {
    formType: FormType.SUB,
    formControls: {
      control: new UntypedFormControl(null)
    },
    toFormGroup: (obj: any | null): any | null => {
      if (!obj) {
        return null;
      }

      return {
        control: obj.control
      };
    },
    fromFormGroup: (formValue: any): any | null => {
      return {
        control: formValue.control
      };
    }
  });

  ngOnInit(): void {
    if (this.validators) {
      this.form.formGroup.controls.control.addValidators(this.validators);
    }
  }

  ngAfterContentInit(): void {
    if (this.default && (!this.form.formGroup.controls.control.value && this.form.formGroup.controls.control.value !== 0)) {
      this.form.formGroup.controls.control.setValue(this.default);
      const pInput: InputNumber = ((this.pnInput as unknown) as InputNumber);
      pInput?.updateInput(this.default, "", "update", this.default.toString());
    }
    
    this.enableDisableInput();
  }

  ngOnChanges(changes: any): void {
    this.enableDisableInput();
    if (changes.validators) {
      this.form.formGroup.controls.control.setValidators(changes.validators.currentValue);
      this.form.formGroup.controls.control.updateValueAndValidity();
    }
  }

  private enableDisableInput() {
    if(this.inputDisabled === true) {
      this.form.formGroup.controls.control.disable();
    } else {
      this.form.formGroup.controls.control.enable();
    }
  }

  isControlInvalid(): boolean {
    const isValid = this.form.formGroup.controls.control.touched && this.form.formGroup.controls.control.invalid; // Skipping dirty check here. This allows errors to show without the form field being dirty.
    return isValid && this.form.formGroup.controls.control.errors != null;
  }
}
